import { render } from "./FilesComponent.vue?vue&type=template&id=c11d4fd4&scoped=true"
import script from "./FilesComponent.vue?vue&type=script&lang=js"
export * from "./FilesComponent.vue?vue&type=script&lang=js"

import "./FilesComponent.vue?vue&type=style&index=0&id=c11d4fd4&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c11d4fd4"]])

export default __exports__